import type { ChipOption } from "../utils/chip-utils";
import { UserMessage } from "./chat-message";
import { Typography } from "./typography";

type Props = {
  question?: string;
  allOptions: ChipOption[];
  selectedIds: Set<string>;
  fallbackSelected: boolean;
  multiSelect: boolean;
  className?: string;
};

export function SubmittedChips({
  question,
  allOptions,
  selectedIds,
  fallbackSelected,
  className,
}: Props) {
  const selectedOptions = allOptions.filter(
    (opt) => selectedIds.has(opt.id) || (opt.id === "__fallback__" && fallbackSelected),
  );

  if (selectedOptions.length === 0) {
    return (
      <div className={`w-full space-y-3 max-w-xl ${className ?? ""}`}>
        {question ? <Typography.AgentText>{question}</Typography.AgentText> : null}
        <Typography.Hint className="italic text-text-tertiary">None selected</Typography.Hint>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      {question ? (
        <Typography.AgentText className="max-w-xl">{question}</Typography.AgentText>
      ) : null}
      <div className={`w-full flex flex-col gap-2 ${className ?? ""}`}>
        {selectedOptions.map((opt) => (
          <UserMessage key={opt.id}>{opt.label}</UserMessage>
        ))}
      </div>
    </div>
  );
}
